<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>问卷调查结果</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div>
          <p></p>
          <p></p>
        </div>
      </div>
      <div class="list">
        <h2>{{ surveyInfo ? surveyInfo.title : '' }}</h2>
        <hr>
        <ul>
          <li
            v-for="(question, index) in questions"
            :key="index"
          >
            <div>
              <span class="question-title">{{ index + 1 }}.</span>
              <span
                class="question-title"
                v-html="question.content"
              ></span>
            </div>
            <div>
              <ul class="question-list">
                <li
                  v-for="(option, op_index) in question.options"
                  :key="op_index"
                >
                  {{ option.code }}. {{ option.title }}
                  <span>{{ getPercent(question.id, option.code) }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StationResearchResult',
  data() {
    return {
      surveyInfo: null,
      allQuestion: [],
      allOption: [],
      userCount: 0,
      userOption: []
    }
  },
  methods: {
    async search () {
      await this.$http.get('/web_survey/' + this.$route.query.survey_id + '/').then((data) => {
        this.surveyInfo = data
      })

      if (this.surveyInfo) {
        await this.$http.get('/web_survey_question/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allQuestion = data.results
        })

        await this.$http.get('/web_survey_question_option/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allOption = data.results
        })

        await this.$http.get('/web_user_survey_question/', {
          params: {
            page: 1,
            size: 1000000,
            webSurvey_id: this.surveyInfo.id
          }
        }).then((data) => {
          const userIds = []
          const userOption = {}

          for (let i = 0; i < data.results.length; i++) {
            if (userIds.indexOf(data.results[i].userSurvey_id) < 0) {
              userIds.push(data.results[i].userSurvey_id)
            }

            if (!(data.results[i].surveyQuestion.id in userOption)) {
              userOption[data.results[i].surveyQuestion.id] = {}
            }
            const selectOption = JSON.parse(data.results[i].selectOption.replaceAll('\'', '"'))

            for (let j = 0; j < selectOption.length; j++) {
              if (selectOption[j] in userOption[data.results[i].surveyQuestion.id]) {
                userOption[data.results[i].surveyQuestion.id][selectOption[j]] += 1
              } else {
                userOption[data.results[i].surveyQuestion.id][selectOption[j]] = 1
              }
            }
          }
          this.userCount = userIds.length
          this.userOption = userOption
        })
      }
    },
    getPercent (questionId, code) {
      if (this.userOption && this.userOption[questionId]) {
        if (!(code in this.userOption[questionId]) || this.userCount === 0) {
          return '0%'
        } else {
          return '' + (this.userOption[questionId][code] * 100 / this.userCount).toFixed(2) + '%'
        }
      } else {
        return '0%'
      }
    }
  },
  mounted() {
    this.search()
  },
  computed: {
    questions () {
      const data = []
      for (let i = 0; i < this.allQuestion.length; i++) {
        const question = this.allQuestion[i]
        question.options = []
        for (let j = 0; j < this.allOption.length; j++) {
          if (this.allOption[j].surveyQuestion_id === question.id) {
            question.options.push(this.allOption[j])
          }
        }
        data.push(question)
      }
      return data
    }
  }
}
</script>

<style lang="less" scoped>
#panel {
  .panel-title {
  }
  .panel-content {
    padding: 20px 40px;
    .course_info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .panel-title {
        p {
          display: inline-block;
          margin-right: 20px;

          &:last-child {
            color: #999;
            font-size: 16px;
          }
        }
      }
      .course_btn {
        div {
          margin-left: 20px;
          padding: 7px 20px;
          background: #73D6CA;
          color: #fff;
          border-radius: 3px;
          &:first-child {
            background: #25c7a8;
          }
          &:nth-child(2) {
            border: 1px solid #73D6CA;
            color: #73D6CA;
            background: #fff;
          }
        }
      }
    }
    .list {
      h2 {
        text-align: center;
      }
      .question-title {
        font-size: 18px;
        display: inline-block;
      }
      .question-del {
        border: 1px solid indianred;
        border-radius: 3px;
        padding: 2px 4px;
        color: indianred;
        float: right;
      }
      .question-list {
        margin: 10px 10px 30px 10px;
      }
      .question-list > li {
        font-size: 16px;
        margin: 4px;
        background-color: #eeeeee;
        input {
          margin-right: 5px;
        }
        span {
          float: right;
          color: green;
        }
      }
    }
    .footer-btn {
      text-align: center;
      .add-btn {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
}

.add-option {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #eee;
  cursor: pointer;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
</style>
